import AWS from 'aws-sdk'
import DocumentClient = AWS.DynamoDB.DocumentClient

// TODO Estos son los que deberian quedar, eliminar el otro types.

export type QueryOptions = {
    startKey?: DocumentClient.Key,
    limit?: number
    sort?: Sort
    textFilters?: TextFilter[]
    valueFilters?: ValueFilter[]
    rangeFilters?: RangeFilter[]
    existsFilters?: ExistsFilter[]
    count?: boolean
}

export type Sort = {
    index: string
    prop: string
    asc?: boolean
}
  
export type TextFilter = {
    text: string
    prop: string
}

export type ValueFilter = {
    value: string | boolean
    prop: string
    equals?: boolean
}

export type RangeFilter = {
    start?: string
    end?: string
    prop: string
}

export type ExistsFilter = {
    exists: boolean
    prop: string
}

// One write of an all-or-nothing transaction. Conditions make the whole transaction fail when the item changed meanwhile
export type TransactWriteOperation = {
    type: 'put'
    dbTableName: string
    item: DocumentClient.AttributeMap
    expectedValues?: DocumentClient.AttributeMap
} | {
    type: 'delete'
    dbTableName: string
    id: string
    mustExist?: boolean
} | {
    type: 'increment'
    dbTableName: string
    id: string
    increments: { [prop: string]: number }
    mustExist?: boolean
}

export const TransactionCancelledErrorName = 'TransactionCancelledError'
